import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

export const projectInfoSlice = createSlice({
  name: "projectInfo",
  initialState: {
    projectInfo: ["Thailand", "Live", "opti_live1"],
    variantProjects: [],
    projects: [
      {
        country: "Thailand",
        env: "Live",
        projectName: "opti_live1",
        tag: "thailand-live"
      },
      {
        country: "India",
        env: "Live",
        projectName: "ira-india",
        tag: "india-live"
      }
    ],
    dateTime: moment(new Date()).format("MMM DD, YYYY hh:mm:ss a")
  },
  reducers: {
    updateProjectInfo(state, action) {
      state.projectInfo = action.payload
    },
    updateDateTime(state, action) {
      state.dateTime = action.payload
    },
    changeProjectConfig(state, action) {
      state.projectInfo = action.payload;
    },
    setVariantProjects(state, action) {
      state.variantProjects = action.payload;
    }
  }
})